import React from "react";
import { TBuilding } from "types/building.types";
import { BuildingContainer, ListContainer } from "./BuildingDropdown.styles";
import UI from "@mile-meeting/mile-ui";
import { debounce } from "lodash";
import DropdownItem from "../../../DropdownItem/DropdownItem";

type BuildingDropdownProps = {
  selectedBuilding?: { name: string; id: string } | null;
  buildingList: (TBuilding | null)[];
  onChange?: (data: { name: string; id: string } | null) => void;
};

const BuildingDropdown: React.FC<BuildingDropdownProps> = ({ selectedBuilding, buildingList, onChange }) => {
  const [search, setSearch] = React.useState<string>("");

  const searchBuilding = debounce((value: string) => {
    setSearch(value);
  }, 300);

  const handleSelectAllBuilding = () => {
    onChange?.({ name: "전체 건물", id: "" });
  };

  const handleSelectedBuilding = (data: TBuilding | null) => {
    if (data) {
      onChange?.({ name: data.name, id: data.id });
    } else {
      //* INFO:  건물 미지정 선택했을 때 로직 처리
      onChange?.(null);
    }
  };

  return (
    <BuildingContainer>
      <UI.Input width={148} placeholder="건물명 검색" size="small" style={{ margin: 6 }} onChange={searchBuilding} />
      <ListContainer>
        <DropdownItem placeholder="전체 건물" onClick={handleSelectAllBuilding} />
        {buildingList
          .filter((item) => item?.name.includes(search) || !item?.name)
          .map((data, index) => (
            <DropdownItem
              key={index}
              onClick={() => handleSelectedBuilding(data)}
              label={data?.name ?? "기타 (건물 미지정)"}
              selected={data ? selectedBuilding?.id === data?.id : selectedBuilding === null}
            />
          ))}
      </ListContainer>
    </BuildingContainer>
  );
};

export default BuildingDropdown;
